import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import { type Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { LANDING_ROUTES } from '@/config/routes';

import { colors } from '@/themesConfig/colors';

const useStyles = makeStyles((theme: Theme) => ({
  duplicateEmailBox: {
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    padding: theme.spacing(2, 4),
    borderRadius: theme.spacing(1),
    backgroundColor: colors.blue,
    color: theme.palette.common.white,

    '& a': {
      color: 'inherit',
    },
  },
}));

export const DuplicateEmailBox = () => {
  const classes = useStyles();

  return (
    <div className={classes.duplicateEmailBox}>
      <Typography variant="body2">
        <Trans i18nKey="landing.signup.duplicateEmailError">
          Oops, we already have an account with your email address.
          <Link to={`.${LANDING_ROUTES.signin}`}>Sign in?</Link>
        </Trans>
      </Typography>
    </div>
  );
};
